/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/map';
import { HttpManagerService } from '../httpmanager.service';
@Injectable()
export class UserDeletedService {
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    allUser(useroffset, pagelimit, countrygroupId, userstatus, applicationId,countrycode): Promise<any> {
        var data = {
            offset: useroffset,
            pagelimit: pagelimit,
            countrygroupId: countrygroupId,
            loginType: userstatus,
            applicationId: applicationId,
            countrycode : countrycode
        }
        return this.httpmanagerService.HttpPost('susersdeleted', JSON.stringify(data), "").then(data => {
            return data.data
        })
    }
    directSearch(searchcontent): Promise<any> {
        var data = {
            searchcontent: searchcontent
        }
        return this.httpmanagerService.HttpPost('susersdeleted/directSearch', JSON.stringify(data), "").then(data => {
            return data.data
        })
    }
    paginationList(countrygroupId, userstatus, applicationId,countrycode): Promise<any> {
        var data = {
            countrygroupId: countrygroupId,
            loginType: userstatus,
            applicationId: applicationId,
            countrycode : countrycode
        }
        return this.httpmanagerService.HttpPost('susersdeleted/paginationlist', JSON.stringify(data), "").then(data => {
            return data
        })
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/userdeleted/userdeleted.service.ts